import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getVat } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'
import { write, utils } from 'xlsx'
import Toggle from 'react-toggle'
import Select from 'react-select'

class Reports extends React.Component {
  state = {
    cruiseList: [],
    typeTagList: [],
    country_list: [],
    Data: [],
    reportUrl: '',
    isSearching: false,

    // filters
    cruiseId: null,
    typeTag: '',
    source: '',
    start_date: '',
    country: '',
    end_date: '',
    booking_date: null,
    booking_from: null,
    booking_to: null,
    bookingStatus: '',

    future_booking_only: false,
  }

  componentDidMount() {
    this.loadData()
    this.setState({
      typeTagList: Constant.getTypeTags(),
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.type !== prevProps.match.params.type) {
      this.setState({
        cruiseId: null,
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        country: '',
        end_date: moment().format('YYYY-MM-DD'),
        booking_date: null,
        booking_from: null,
        booking_to: null,
        bookingStatus: '',

        Data: [],
      })
    }
  }

  loadData() {
    this.setState(
      {
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      () => {
        // this.detailsSummary()
      }
    )

    // this.getCruiseList()
    this.getCountries()
  }

  getCruiseList = async (country) => {
    this.setState({ cruiseList: [], cruiseId: null })
    var that = this
    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            cruiseList: res?.data?.data?.map((itm) => ({
              label: `${itm.cruise_name_en}/${itm.cruise_name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  clearSearch = async () => {
    this.setState({
      bookingStatus: '',
      country: '',
      cruiseId: null,
      start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      booking_from: '',
      booking_to: '',
      typeTag: '',
      source: '',

      booking_date: '',
      Data: [],

      future_booking_only: false,
    })
  }

  searchData = async () => {
    this.detailsSummary()
  }

  detailsSummary = async () => {
    var that = this
    var dateDMY1 = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY2 = moment(this.state.end_date).format('MM/DD/YYYY')
    let data = {
      bookingStatus: that.state.bookingStatus ? that.state.bookingStatus : null,
      country: this.state.country,
      typeTag: this.state.typeTag,
      source: this.state.source,
    }

    if (dateDMY1 && dateDMY1 != 'Invalid date') data.bookingDateFrom = dateDMY1
    if (dateDMY2 && dateDMY2 != 'Invalid date') data.bookingDateTo = dateDMY2
    if (that.state.cruiseId) data.cruiseId = that.state.cruiseId?.value || ''
    if (that.state.booking_date) data.booking_date = that.state.booking_date
    if (that.state.booking_from) data.booking_from = moment(that.state.booking_from).format('MM/DD/YYYY')
    if (that.state.booking_to) data.booking_to = moment(that.state.booking_to).format('MM/DD/YYYY')

    this.setState({
      isSearching: true,
    })
    await axios
      .post(Constant.getAPI() + `/reports/booking-details-summary-v2`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details?.[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 6
    if (diffMonths > 6) {
      return true
    } else {
      return false
    }
  }

  handleChange = (event) => {
    event.persist()

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (
          (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
          this.checkDateDifference(this.state.start_date, this.state.end_date)
        ) {
          if (event?.target?.name == 'start_date') {
            this.setState({
              end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD'),
            })
          } else {
            this.setState({
              start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD'),
            })
          }
        }
      }
    )

    if (event?.target?.name == 'country') {
      this.setState({ cruiseList: [], cruiseId: null })
      if (event.target.value != '') {
        this.getCruiseList(event.target.value)
      }
    }
  }

  toggleFutureBookingOnly = (event) => {
    this.setState({
      future_booking_only: event.target.checked,
      start_date:
        event.target.checked == true
          ? moment().subtract(2, 'years').format('YYYY-MM-DD')
          : moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      booking_from: event.target.checked == true ? moment().format('YYYY-MM-DD') : '',
      booking_to: event.target.checked == true ? moment().add(1, 'years').format('YYYY-MM-DD') : '',
    })
  }

  handleClear = () => {
    this.setState({ cruiseId: null })
  }

  handleCruiseChange = (event) => {
    this.setState({
      cruiseId: event,
    })
  }

  render() {
    let columns = []

    if (this.props.match.params.type == 'customer-booking-report') {
      columns = [
        {
          name: 'CUSTOMER_NAME',
          label: 'Customer Name',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'PHONE',
          label: 'Customer Phone',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CUSTOMER_EMAIL',
          label: 'Customer Email',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CUSTOMER_DOB',
          label: 'Customer dob',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'ORDER_NUMBER',
          label: 'Booking ID',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'TRIP_DATE',
          label: 'Booking Date',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'BOOKING_AMOUNT',
          label: 'Total Amount',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'BOOKING_STATUS',
          label: 'Booking Status',
          options: {
            filter: true,
            sort: true,
          },
        },
      ]
    } else {
      columns = [
        {
          name: 'COUNTRY',
          label: 'Country',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'ORDER_NUMBER',
          label: 'Order Number',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CUSTOMER_NAME',
          label: 'Customer Name',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'PHONE',
          label: 'Customer Phone',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CAPTAIN_PHONE',
          label: 'Captain Phone',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'BOOKING_DATE',
          label: 'Issue Date',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'TRIP_DATE',
          label: 'Booking Date',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CRUISE_TYPE',
          label: 'Cruise Type',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CRUISE_NAME_EN',
          label: 'Cruise Name English',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'CRUISE_NAME_AR',
          label: 'Cruise Name Arabic',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'START_TIME',
          label: 'Start Time',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'END_TIME',
          label: 'End Time',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'BOOKING_HOURS',
          label: 'Booking Duration',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'PICKUP_POINT',
          label: 'Pickup',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'DESTINATION_POINT',
          label: 'Destination',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'TYPE_TAG',
          label: 'Booking tag type',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'BOOKING_AMOUNT',
          label: 'Total Amount',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'CRUISE_AMOUNT',
          label: 'Cruise Amount',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'INVOICE_REFERENCE_ID',
          label: 'Order Reference Id',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'PAYMENT_METHOD',
          label: 'Payment Method',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
          },
        },
        {
          name: 'BOOKING_STATUS',
          label: 'Booking Status',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'COUPON_CODE',
          label: 'Coupon',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'COUPON_APPLIED_AMOUNT',
          label: 'Discount Amount',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'WALLET_AMOUNT_APPLIED',
          label: 'Wallet Applied Amount',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'VAT',
          label: 'Vat',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta) => {
              return value ? value + ` (${getVat(tableMeta.rowData[0])}%)` : '--'
            },
          },
        },
        {
          name: 'DELIVERY_CHARGE',
          label: 'Delivery Charge',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'ADDITIONAL_ITEMS',
          label: 'Additional Items',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'ADDITIONAL_ITEMS_AMOUNT',
          label: 'Additional Items Amount',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'DIWANIYA_ITEMS',
          label: 'Diwaniya Items',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'DIWANIYA_ITEMS_AMOUNT',
          label: 'Diwaniya Items Amount',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
        {
          name: 'BOOKING_COMMENTS',
          label: 'Comments',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) =>
              value ? (
                <div style={{ textWrap: 'nowrap' }}>
                  {value.split(', ').map((itm) => (
                    <>
                      {itm}
                      <br />
                    </>
                  ))}
                </div>
              ) : (
                '--'
              ),
          },
        },
        {
          name: '',
          label: 'Trip Date & Time',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta) => {
              return <div style={{ textWrap: 'nowrap' }}>{tableMeta.rowData[6] + ' ' + tableMeta.rowData[10]}</div>
            },
          },
        },
        {
          name: 'DEVICE_TYPE',
          label: 'Device Type',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => (value == 'W' ? 'Website' : value || '--'),
          },
        },
        {
          name: 'DEVICE_NAME',
          label: 'Device Name',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '--',
          },
        },
      ]
    }

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (columns[idx].label && columns[idx].label != 'Trip Date & Time') {
              temp[columns[idx].label] = v
            }
          })
          if (temp?.TRIP_DATE && temp?.START_TIME) {
            temp.TRIP_DATE_TIME = temp.TRIP_DATE + ' ' + temp.START_TIME
          }
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>
                        {this.props.match.params.type == 'customer-booking-report'
                          ? 'Customer Booking Report'
                          : 'Basic Report'}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {this.props.match.params.type == 'customer-booking-report'
                          ? 'Customer Booking Report'
                          : 'Basic Report'}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Booking Status</label>
                            <div className="col-sm-9">
                              <select
                                name="bookingStatus"
                                className="form-control"
                                value={this.state.bookingStatus}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                <option value={'Pending'}>Pending</option>
                                <option value={'Successful'}>Successful</option>
                                <option value={'Cancelled'}>Cancelled</option>
                                <option value={'Confirmed'}>Confirmed</option>
                                <option value="Postponed">Postponed</option>
                                <option value={'Incomplete'}>Incomplete</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Cruise Name</label>
                            <div className="col-sm-9">
                              <Select
                                name="cruiseId"
                                value={this.state.cruiseId}
                                onChange={this.handleCruiseChange}
                                options={this.state.cruiseList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder="Select Options"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Tag Type</label>
                            <div className="col-sm-9">
                              <select
                                name="typeTag"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.typeTag}
                              >
                                <option value={''}>All</option>
                                {this.state?.typeTagList?.length > 0
                                  ? this.state.typeTagList.map((tag) => (
                                      <option
                                        value={tag}
                                        key={tag}
                                      >
                                        {tag}
                                      </option>
                                    ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Source</label>
                            <div className="col-sm-9">
                              <select
                                name="source"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.source}
                              >
                                <option value={''}>All</option>
                                <option value={'wego'}>Wego</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12"
                          style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                        ></div>
                        <div className="col-4">
                          <div className="form-group row">
                            <label className="col-8 col-form-label">Future bookings Only</label>
                            <div className="col-4">
                              <Toggle
                                className="f-right"
                                checked={this.state.future_booking_only == true ? true : false}
                                onChange={this.toggleFutureBookingOnly}
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.future_booking_only && (
                          <>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Booking From Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    id="date"
                                    name="booking_from"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.booking_from}
                                    min={moment().format('YYYY-MM-DD')}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {!this.state.future_booking_only && (
                          <>
                            <div
                              className="col-12"
                              style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                            ></div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Created Start Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    id="date"
                                    name="start_date"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.start_date}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Created End Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    max={moment().format('YYYY-MM-DD')}
                                    id="date"
                                    name="end_date"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.end_date}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">
                                  Booking Date
                                </label>
                                <div className="col-md-9">
                                  <input type="date"
                                    id="booking_date"
                                    className="form-control"
                                    value={this.state.booking_date}
                                    name="booking_date"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div> */}
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking start</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_from"
                                    className="form-control"
                                    value={this.state.booking_from}
                                    name="booking_from"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking To</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_to"
                                    className="form-control"
                                    value={this.state.booking_to}
                                    name="booking_to"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              1. You can get maximum 6 months rocords at a time
                              {!this.state.start_date &&
                                !this.state.end_date &&
                                !this.state.booking_from &&
                                !this.state.booking_to && (
                                  <span>
                                    <br />
                                    2. Either select Booking dates or Created dates
                                  </span>
                                )}
                            </div>
                            <div className="text-right col-6">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.searchData}
                                    disabled={
                                      (!this.state.start_date && this.state.end_date) ||
                                      (this.state.start_date && !this.state.end_date) ||
                                      (!this.state.booking_from && this.state.booking_to) ||
                                      (this.state.booking_from && !this.state.booking_to) ||
                                      (!this.state.start_date &&
                                        !this.state.end_date &&
                                        !this.state.booking_from &&
                                        !this.state.booking_to)
                                    }
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Booking Details Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Reports
